import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { UserManager } from '../../../utils';
import { loginActions } from "../../../store/user-login.reducer";

class SilentRenewCallback extends Component {

    componentDidMount() {
        UserManager.signinSilentCallback()
            .catch((error) => {
                console.log('Signin Silent Callback Error');
                console.log(error);
            });
    }


    render() {
        return (
            <div>
                Silent Renew Callback
            </div>
        );
    }
    
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(loginActions, dispatch)
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
        return {
            ...authentication
        };
}
export default connect(mapStateToProps, mapDispatchToProps)(SilentRenewCallback);
